export const CONFLICTED_ERROR_CODE = 409;
export const HAS_FUTURE_APPOINTMENT_ERROR_CODE = 422;
export const TOO_MANY_REQUESTS_ERROR_CODE = 429;
export const RESCHEDULE_PARTIAL_FAILED_ERROR_CODE = 206;
export const REALLOCATE_PARTIAL_FAILED_ERROR_CODE = 206;

export const CREATED_SUCCESS_CODE = 201;
